export const zIndexOverDrawer = 1300

export const steps = [
  {
    title: 'Prepara tu archivo',
    description:
      'exporta la plantilla que necesites (Inventario global o Precios de exportación) y actualiza los valores de los productos que quieras cambiar.',
  },
  {
    title: 'Sube tu archivo',
    description:
      'selecciona abajo tu archivo CSV o Excel actualizado y súbelo. El tipo de plantilla se detecta automáticamente.',
  },
  {
    title: 'Revisa los resultados de la importación',
    description:
      'consulta los resultados de la validación en tiempo real mientras se procesa tu archivo. Si alguna fila tiene errores, puedes corregirla en pantalla o descargarla en el mismo formato que tu archivo.',
  },
]
